export default "__VITE_ASSET__32855e05__"